import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/aquarist/www/pipeclub/layouts/default.vue")),
  "home-layout": defineAsyncComponent(() => import("/home/aquarist/www/pipeclub/layouts/home-layout.vue")),
  "shop-layout": defineAsyncComponent(() => import("/home/aquarist/www/pipeclub/layouts/shop-layout.vue"))
}